var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observer } from "mobx-react";
import React from "react";
import { StoreContext } from "../uistore/PwaRootStore";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Textarea } from '@chakra-ui/react';
import { testIsMobile } from "@@/Util";
let PwaAiForm = class PwaAiForm extends React.Component {
    constructor(prop) {
        super(prop);
        this.ref = null;
        this.state = {
            useslow: false,
            prompt: "",
            b64images: []
        };
    }
    async filesSelected() {
        const rstore = this.context;
        if (this.ref && this.ref.files) {
            // lets add them now!!
            let fs = [];
            for (const ff of this.ref.files) {
                const reader = new FileReader();
                reader.readAsDataURL(ff);
                const b64 = await new Promise((ac, err) => {
                    reader.onload = function () {
                        var _a, _b;
                        ac((_b = (_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '');
                    };
                    reader.onerror = function (error) {
                        console.log('Error: ', error);
                        ac("");
                    };
                });
                if (b64) {
                    fs.push(b64.split(',')[1]);
                }
                this.setState({ b64images: fs });
            }
            /*
            if(this.state.useslow) {
                rstore.getPwaStore().ocrFileOnBackend(fs);
            }else {
                rstore.getPwaStore().ocrFile( fs);
            }*/
            this.ref.value = '';
        }
    }
    async componentDidMount() {
        const rstore = this.context;
        const pt = await rstore.getPwaStore().getAIPrompt();
        this.setState({ prompt: pt, b64images: [] });
    }
    render() {
        const rstore = this.context;
        return React.createElement(Box, { margin: 'auto', marginTop: '10px', w: window.innerWidth < 1100 ? window.innerWidth - 20 : window.innerWidth - 100, h: '100%' },
            React.createElement(Box, { mt: '10px', pos: 'relative', bg: 'whiteAlpha.400', boxShadow: '0 0 5px #b6b6b6', w: window.innerWidth < 1100 ? window.innerWidth - 20 : window.innerWidth - 100, h: testIsMobile() ? window.innerHeight - 250 + "px" : '500px', borderWidth: 1, borderColor: '#dfdfdf' },
                React.createElement(Flex, { height: '30px', flexWrap: 'wrap', align: 'center' },
                    React.createElement("input", { style: { display: 'none' }, accept: "image/png, image/jpeg", ref: (ref) => this.ref = ref, type: 'file', multiple: true, onChange: () => {
                            this.filesSelected();
                        } }),
                    React.createElement(Button, { onClick: () => {
                            var _a;
                            //we need to let them upload file here!
                            (_a = this.ref) === null || _a === void 0 ? void 0 : _a.click();
                        } }, "Upload Image"),
                    React.createElement(Button, { marginLeft: '10px', onClick: () => {
                            // now we just need to run ai!
                            let pt = "";
                            if (this.state.prompt) {
                                pt = this.state.prompt;
                            }
                            rstore.getPwaStore().runAi(pt, this.state.b64images);
                        } }, "Parse"),
                    React.createElement(Button, { marginLeft: '10px', onClick: () => { rstore.getPwaStore().setAddNewViewEntryViaAi(false); } }, "Close"),
                    React.createElement(Text, { marginLeft: '10px' }, rstore.getPwaStore().aimessages)),
                React.createElement(Text, { marginTop: '30px', fontWeight: 'bold' }, "Total images selected " + this.state.b64images.length),
                React.createElement(Textarea, { marginTop: '30px', placeholder: "Prompt", value: this.state.prompt, onChange: (e) => this.setState({ prompt: e.currentTarget.value }) }),
                React.createElement(Textarea, { marginTop: '30px', placeholder: "Extra  Ai Text", value: rstore.getPwaStore().aicontent, onChange: (val) => {
                        rstore.getPwaStore().setAiContent(val.currentTarget.value);
                    } })));
    }
};
PwaAiForm.contextType = StoreContext;
PwaAiForm = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], PwaAiForm);
export { PwaAiForm };
